"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetNovageSkincareConfiguration = void 0;
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _presentationUtils = require("@ori/presentation-utils");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _constantsGenerated = require("../constants-generated");
/* istanbul ignore file @preserve -- api */

const useGetNovageSkincareConfiguration = enabled => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const {
    data
  } = (0, _staticApiClientReact.useGetTenantApplicationsAdvisorNovAgeSkincareConfiguration)(tenant, {
    lang: language
  }, {
    request: {
      headers: (0, _fetching.getHeaders)({
        language,
        sourceAppName: _constantsGenerated.PACKAGE_NAME,
        tenant
      })
    },
    swr: {
      ...(0, _presentationUtils.getRetryErrorSwrOptions)(),
      enabled
    }
  });
  return data;
};
exports.useGetNovageSkincareConfiguration = useGetNovageSkincareConfiguration;
